import styled from "styled-components";

export const VacancyDetailsPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const VacancyDetailsPageTable = styled.div`
  background-color: #edf1fc;
  padding: 40px;
  border-radius: 24px;
  gap: 20px;
  max-width: 1800px;
  margin: 40px auto;
  z-index: 10;
  width: 90%;
  height: 100%;
  background-image: url("/assets/bg.png");
`;

export const VacancyDetailsPageTitle = styled.h1`
  color: #17224d;
  margin-bottom: 30px;
  text-align: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-top: 20px;
  position: relative;
  padding-bottom: 20px;

  @media (max-width: 780px) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
`;

export const Button = styled.button`
  padding: 12px 20px;
  font-size: 16px;
  color: white;
  border: none;
  margin-top: 10px;
  margin-right: 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  @media (max-width: 780px) {
    width: 100%;
    margin-right: 0;
  }
`;

export const SolliciteerButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.darkblue};

  &:hover {
    background-color: ${({ theme }) => theme.colors.darkblue};
  }
`;

export const ContactButton = styled(Button)`
  background-color: #28a745;

  &:hover {
    background-color: #218838;
  }
`;

// Back button styles (inside buttons container but at the bottom right)
export const BackButton = styled(Button)`
  position: absolute;
  bottom: 10;
  right: 0;
  margin-right: 20px;
  background-color: ${({ theme }) => theme.colors.darkblue};
  color: ${({ theme }) => theme.colors.white};

  &:hover {
    background-color: ${({ theme }) => theme.colors.darkblue};
  }

  @media (max-width: 780px) {
    position: static;
    margin-right: 0;
  }
`;

export const VacancyDetailsResultCard = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  margin: 0 auto;

  @media (max-width: 640px) {
    width: 100%;
  }
`;

export const VacancyDetailsContent = styled.p`
  font-size: 16px;
  color: #17224d;
  line-height: 1.5;
`;

export const VacancyDetailsLink = styled.a`
  font-size: 16px;
  color: #0066cc;
  text-decoration: none;
  font-weight: bold;
`;
